export default window.__env



// WEBPACK FOOTER //
// ./src/client/misc/env.js